export const COMPANIES = {
    UNID: 'UNID',
    UERRE: 'UERRE'
};

export const EDU_OFFER = {
    LICENCIATURA: 'LI',
    MAESTRIA: 'MA'
}